
<div class="topDiv">
    <div class="agGridOuterDiv"  style="margin-top: 3%;padding-left: 10px;padding-right:10px">
        <body onload="embedDashboard()" style="margin-top: 25px;">
            <div>

                <div class="row topRowMargins headerStyle">
    
                    <div class="col-lg-12" style="    display: flex;
                    justify-content: space-between;">
                        <div>
                        Reports and Analytics
                    </div>
                    <div>
                    <button title="Save" (click)="savedata()" class="btn btn-outline btn-rounded btn-sm waves-effect waves-light"  style="padding: 0.4rem .9rem;
                    margin-top: 0rem;
                    background: #3f7fb5;
                    font-size: 10px;
                    font-weight: 500;">
                        <em class="fas fa-upload"></em> Save
                        </button>
                    </div>
                </div>
                </div>
    
            </div>
            <div #embeddingContainer id="embeddingContainer" style="height: 75vh;"></div>
        </body>
    </div>
    </div>
